/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig';

export class GcpRestoreAccountConnectivityConfig {
  /**
  * Networks to configure.
  */
  'networkConfigs'?: Array<GcpNetworkConnectivityConfig>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networkConfigs",
      "baseName": "networkConfigs",
      "type": "Array<GcpNetworkConnectivityConfig>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpRestoreAccountConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

